import type { AdsType } from "./types";

export const ALL_ADS_TYPES: AdsType[] = ["Display", "Search", "Shopping", "Social"];
